import 'bootstrap'
import jQuery from 'jquery'
import type CustomWindow from '@/misc/custom-window'

declare let window: CustomWindow

window.$ = window.jQuery = jQuery

export {}
